"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const notPublishedBadge_1 = __importDefault(require("./notPublishedBadge"));
const pageTypeBadge_1 = __importDefault(require("./pageTypeBadge"));
const publishedBadge_1 = __importDefault(require("./publishedBadge"));
const PageBadgeGroup = ({ pageType, isPublished, className }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('_d-flex _align-items-center', className), children: [(0, jsx_runtime_1.jsx)(pageTypeBadge_1.default, { pageType: pageType, className: "_mr-4" }), isPublished ? (0, jsx_runtime_1.jsx)(publishedBadge_1.default, {}) : (0, jsx_runtime_1.jsx)(notPublishedBadge_1.default, {})] }));
};
exports.default = PageBadgeGroup;
